<template>
  <v-dialog v-model="dialogOpen" persistent max-width="450">
    <v-card>

      <v-card-title>Void Lead</v-card-title>
      
      <v-card-text>
        <v-form >
          <v-row>
            <v-col cols="12" md="12">
              <v-select hide-details dense label="Void Reason" outlined required return-object :items="getVoidReasonsArr(lead.kind)" v-model="voidReason" :error-messages="voidReasonErrors"></v-select>
            </v-col>
          </v-row>
          
          <v-row>
            <v-col cols="12" md="12">
              <v-textarea hide-details dense label="Void Reason Notes" v-model="voidReasonNotes" outlined placeholder="Type here...">
              </v-textarea>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" small @click.prevent="submit" :loading="saving">Save</v-btn>
        <v-btn color="primary" small outlined class="ml-3" @click="$emit('close-dialog')">Cancel</v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
import { mapState,mapActions,mapGetters } from "vuex";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],

  validations: {
    voidReason: {
      text: { required }
    },
  },

  data: () => ({
    saving: false,
    voidReasonNotes: '',
    voidReason: {
      text: "",
      value: ""
    },
  }),

  props: ['dialogOpen','lead'],

  computed: {
    ...mapState("globals", ["selectedAddress"]),
    ...mapGetters("daily", ["getVoidReasonsArr", 'getAddVoidReasonError', 'getVoidDailyLeadError']),

    voidReasonErrors() {
      const errors = [];
      if (!this.$v.voidReason.$dirty) return errors;
      !this.$v.voidReason.text.required && errors.push("Void reason is required");
      return errors;
    },
  },

  watch: {
    dialogOpen: {
      immediate: false,
      async handler() {
        await this.getVoidReasons();
      }
    }
  },

  methods: {
    ...mapActions('daily', ['addVoidReason','voidDailyLead','getVoidReasons']),
    ...mapActions('alerts', ['setAlert']),
    ...mapActions('leads', ['getLeadByID']),

    async submit(){
      this.$v.$touch();

      if (this.$v.$pending || this.$v.$error) return;

      let payload = {
        void_reason: this.voidReason.text,
        void_notes: this.voidReasonNotes,
      };

      this.saving = true;
      let p_id = this.lead.id;
      let status = 'Void';
      try {
        await this.addVoidReason({ leadId: this.lead.id, payload: payload });
        await this.voidDailyLead({ p_id, payload: { status } });

        if (!this.getAddVoidReasonError && !this.getVoidDailyLeadError) {
          this.setAlert({type: 'success', message: `Added void reason notes for ${this.lead.id} and Voided Successfully`});
        }

        await this.getLeadByID({id:this.lead.id});
      } catch(error) {
        this.setAlert({type: 'error', message: `Error adding void reason notes: ${error}`});
      } finally {
        this.saving = false;
        this.$emit('close-dialog');
      }
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
